
(() => {
  const trapStack = [];

  function focusableIn(container) {
    return Array.from(container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])'
    )).filter((el) => el.offsetParent !== null || el === document.activeElement);
  }

  window.ThemeUtils = {
    fetchConfig(type = 'json') {
      return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
      };
    },

    debounce(fn, wait = 200) {
      let t;
      return (...args) => { clearTimeout(t); t = setTimeout(() => fn(...args), wait); };
    },

    throttleRaf(fn) {
      let ticking = false;
      return (...args) => {
        if (ticking) return;
        ticking = true;
        requestAnimationFrame(() => { ticking = false; fn(...args); });
      };
    },

    formatMoney(cents, format) {
      const value = Number(cents) / 100;
      if (!format) {
        const symbol = window.themeStrings?.currencySymbol || '\u20ac';
        const body = Number.isInteger(value)
          ? String(value)
          : value.toFixed(2).replace('.', ',');
        return `${body}\u00a0${symbol}`;
      }
      const fmt = format;
      const variants = {
        amount: value.toFixed(2),
        amount_no_decimals: String(Math.round(value)),
        amount_with_comma_separator: value.toFixed(2).replace('.', ','),
        amount_no_decimals_with_comma_separator: String(Math.round(value)),
        amount_with_apostrophe_separator:
          value.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, "'"),
      };
      return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, (_, key) => variants[key] ?? variants.amount);
    },

    lockScroll() {
      const count = Number(document.body.dataset.scrollLocks || 0);
      if (count === 0) {
        const gap = window.innerWidth - document.documentElement.clientWidth;
        document.body.style.paddingRight = gap > 0 ? `${gap}px` : '';
        document.body.classList.add('scroll-locked');
      }
      document.body.dataset.scrollLocks = count + 1;
    },
    unlockScroll() {
      const count = Math.max(0, Number(document.body.dataset.scrollLocks || 0) - 1);
      document.body.dataset.scrollLocks = count;
      if (count === 0) {
        document.body.classList.remove('scroll-locked');
        document.body.style.paddingRight = '';
      }
    },

    trapFocus(container, initialFocus) {
      const handler = (e) => {

        if (trapStack[trapStack.length - 1]?.handler !== handler) return;
        if (e.key !== 'Tab') return;
        const focusable = focusableIn(container);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
        else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
      };
      trapStack.push({ container, handler, returnTo: document.activeElement });
      document.addEventListener('keydown', handler);
      const target = initialFocus || focusableIn(container)[0] || container;
      target.focus({ preventScroll: true });

      if (document.activeElement !== target && !container.contains(document.activeElement)) {
        container.setAttribute('tabindex', '-1');
        container.focus({ preventScroll: true });
      }
    },

    isTopLayer(container) {
      const top = trapStack[trapStack.length - 1];
      return !top || top.container === container || container.contains(top.container);
    },

    releaseFocus(container) {
      const idx = trapStack.findIndex((t) => t.container === container);
      if (idx === -1) return;
      const { handler, returnTo } = trapStack[idx];
      document.removeEventListener('keydown', handler);
      trapStack.splice(idx, 1);
      if (returnTo && document.contains(returnTo)) returnTo.focus({ preventScroll: true });
    },

    replaceSection(targetSelector, sectionHtml, innerSelector) {
      const target = document.querySelector(targetSelector);
      if (!target || !sectionHtml) return;
      const doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
      const source = innerSelector ? doc.querySelector(innerSelector) : doc.body.firstElementChild;
      if (source) target.replaceWith(source);
    },
  };
})();
